import {API} from "../api/axios";
const END_POINT = "/teachers";
const END_POINT_TEACHER = "/teacher";
const END_POINT_FILTER = "/homeworks-filter";
const END_POINT_ENABLE = "/enable-disable-teacher";
const END_POINT_ENABLE_ADMIN = "/users/{user}/block";

class TeacherService {
  getAll(params) {
    return API.get(END_POINT, params);
  }
  getFilterCourses(params) {
    return API.get(END_POINT_FILTER, params);
  }
  get(id, params) {
    return API.get(`${END_POINT_TEACHER}${END_POINT}/${id}`, params);
  }
  create(data) {
    return API.post(END_POINT_TEACHER, data);
  }
  update(id, data) {
    return API.post(`${END_POINT_TEACHER}/${id}`, data);
  }
  delete(id) {
    return API.delete(`${END_POINT_TEACHER}/${id}`);
  }
  deleteAll(params) {
    return API.delete(`${END_POINT}`, params);
  }
  enableTeacher(id, data) {
    return API.post(`${END_POINT_ENABLE}/${id}`, data);
  }
  enableAdmin(userId, data) {
    const url = END_POINT_ENABLE_ADMIN.replace("{user}", userId);
    return API.put(url, data);
  }
}

export default new TeacherService();
